import { render } from "./KontaktSeite.vue?vue&type=template&id=058fb0a0&scoped=true"
import script from "./KontaktSeite.vue?vue&type=script&lang=js"
export * from "./KontaktSeite.vue?vue&type=script&lang=js"

import "./KontaktSeite.vue?vue&type=style&index=0&id=058fb0a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058fb0a0"]])

export default __exports__